import { Model } from './model';
import { Project } from './project';
import { RegionAttachable, WidgetMap } from './widget';

/*export enum ObjectStatus {
 ForSale,
 Sold,
 Booked,
 Reserved,
 Removed
 }*/

export type ObjectStatus = "ForSale" | "Sold" | "Booked" | "Reserved" | "Removed" | "Display";

export const ObjectStatus = {
  ForSale: "ForSale" as ObjectStatus,
  Sold: "Sold" as ObjectStatus,
  Booked: "Booked" as ObjectStatus,
  Reserved: "Reserved" as ObjectStatus,
  Removed: "Removed" as ObjectStatus,
  Display: "Display" as ObjectStatus,
};

export class PObject extends Model implements RegionAttachable {
  guid: string;
  number: string;
  status: ObjectStatus;
  price: number;
  monthlyFee: number;
  published: boolean;
  rooms: number;
  livingArea: number;
  balconyArea: number;
  balconyView: number;
  floorNumber: number;
  floorMax: number;
  inhabitDate: Date;
  readonly: boolean;
  project: Project;
  maps: WidgetMap[];

  constructor(data?) {
    super(data);
    if (data) {
      this.guid = data.guid;
      this.number = data.number;
      if (data.price) {
        this.price = data.price.amount;
      }
      this.readonly = data.readonly;
      this.status = ObjectStatus[data.status];
      this.monthlyFee = data.monthly_fee ? data.monthly_fee.amount : null;
      this.published = !!data.is_published;
      this.rooms = data.rooms;
      this.livingArea = data.living_area;
      this.balconyArea = data.balcony_area;
      this.balconyView = data.balcony_view;
      this.floorNumber = data.floor_number;
      this.floorMax = data.floor_max;
      this.inhabitDate = data.inhabit_date;
      this.project = new Project(data.project);
      this.maps = data.maps ? data.maps.data.map(m => new WidgetMap(m)) : null;
    }
  }

  toJson(): any {
    return {
      number: this.number,
      status: this.status,
      rooms: this.rooms,
      price: this.price,
      monthly_fee: this.monthlyFee,
      living_area: this.livingArea,
      balcony_area: this.balconyArea,
      floor_number: this.floorNumber,
      balcony_view: this.balconyView
    };
  }

  getId() {
    return this.id;
  }

  text() {
    return this.number;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/object.ts